export default {
  globalStoreName: "smartmap-global-store",
  apiUrl: "https://scbsk.v4.smartmap.sk/backend",
};
